import Vue from 'vue'
import VueRouter from 'vue-router'
import config from '../config'
import { setAppTitleBar } from '../components/app'
import Bus from '../utils/bus'

Vue.use(VueRouter)

/*
  路由懒加载
*/
const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('../views/home.vue'),
    meta: { title: '暑期夏令营主会场' }
  }
]

const router = new VueRouter({
  routes
})

router.afterEach(to => {
  document.title = to.meta.title || '学而思网校'

  const pageConfig = config.xesLog.pages[to.name]
  if (pageConfig) {
    setTimeout(() => {
      /*
        每个页面配置统一的 pageuid、pagename、pagelevel
        页面中发埋点日志时，不需要再单独配置如上参数
      */
      const { uid, name } = pageConfig
      // 点击埋点公共参数注入
      Vue.prototype.$xesLogger.setCommonParam({
        pageuid: uid,
        pagename: name,
        pagefrom: window._wltfChannel.urlParams.from === 'miniprogram' ? 'miniprogram' : 'h5',
        sourceId:
          window._wltfChannel.urlParams.xeswx_sourceid ||
          window._wltfChannel.urlParams.sourceId ||
          window._wltfChannel.hotUrlParams.source ||
          window._wltfChannel.urlParams.sourceid ||
          '',
        channelId: window._wltfChannel.urlParams.channelId || '',
        sGroupId: '13339481',
        invitedId: window._wltfChannel.urlParams.inviterId || ''
      })

      // 进入页面时发送展现日志
      Vue.prototype.$xesLogger.loadMsg({ clickid: '1', elemname: '主页面曝光' })
    }, 300)
    window.xesApp &&
      setAppTitleBar(
        {
          title: '暑期夏令营主会场'
        },
        () => {
          Bus.$emit('share')
        }
      )
  }
})

export default router
